/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateSnippetDataParser = /* #__PURE__ */ parsers.object([
    ['key', codecString],
    ['value', codecString],
]);
export class CreateSnippetData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateSnippetDataParser.decode(input).map(res => new CreateSnippetData(res));
    }
    static unsafeDecode(input) {
        return CreateSnippetData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateSnippetDataParser.encode(data);
    }
    static schema() {
        return CreateSnippetDataParser.schema();
    }
}
